import React from 'react';
import {withTranslation} from 'react-i18next';
import axios from "axios";
import {getRequestConfig} from "tunnel-commande/src/utils";
import Icons from "../Icons";
import {getShopInfosInStorage} from "tunnel-commande/src/components/cart/ShopInfos";
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import {renderPriceDecimals} from "../RenderDT";
import { isEqual } from '../../utils';
import {withHostApi} from "../../contexts/HostApiContext";

class PriceArticle extends React.Component<any, any> {
  private cancelRequestPrice: any;
  private timeoutId: any;
  private readonly quantiteMin: any = null;
  private lang: string;
  private franco: any = null;
  private _isMounted: boolean;

  constructor(props: any) {
    super(props);

    this.timeoutId = null;
    this.cancelRequestPrice = null;
    this.quantiteMin = getShopInfosInStorage() ? getShopInfosInStorage().quantiteMin : 10;
    this.franco = getShopInfosInStorage() ? getShopInfosInStorage().franco : 29;
    this.lang = this.props.i18n.language;
    this._isMounted = false;

    this.state = {
      price: {},
      defaultPrice: !this.props.fileUploaded && this.props.isTransfert
    };
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  componentDidMount(): void {
    this._isMounted = true;
    this.lang = this.props.i18n.language;
    const localeMoment = this.lang === 'fr' ? this.lang : 'en-gb';
    moment.locale(localeMoment);
    if(this.state.defaultPrice) {
      this.refreshPrice();
    }

  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, _snapshot?: any): void {
    if((!isEqual(this.props.articleData, prevProps.articleData)) && this.canHavePrice()) {
      if(this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      const timeoutDelay = (isEqual(this.props.articleData.quantite, prevProps.articleData.quantite)) ? 0 : 250;

      this.timeoutId = setTimeout(() => {
        this.refreshPrice();
        this.timeoutId = null;
      }, timeoutDelay);
    } else if (!isEqual(this.props.articleData, prevProps.articleData) && !this.canHavePrice() && (Object.keys(this.state.price).length !== 0)) {
      this.setState({
        price: {}
      });
    }
    if(prevProps.i18n.language !== this.lang) {
      this.lang = this.props.i18n.language;
      const localeMoment = this.lang === 'fr' ? this.lang : 'en-gb';
      moment.locale(localeMoment);
    }
    if(this.props.isTransfert && prevProps.fileUploaded !== this.props.fileUploaded && this.state.defaultPrice != !this.props.fileUploaded) {
      this.setState({
        defaultPrice: !this.props.fileUploaded
      }, () => {
        this.refreshPrice();}
    );
    }

  }

  private canHavePrice() {
    if(this.props.isTransfert) {
      return this.props.articleData.quantite && this.props.articleData.quantite >= this.quantiteMin;
    } else {
      return this.props.articleData.quantite && this.props.articleData.quantite >0;
    }
  }

  private refreshPrice() {

    if(this.cancelRequestPrice) {
      this.cancelRequestPrice();
    }
    let params = {
      quantites: this.props.articleData.quantites,
      quantite: this.props.articleData.quantite,
      largeur: this.props.articleData.largeur,
      hauteur: this.props.articleData.hauteur,
      isTransfer: this.props.isTransfert,
      article_id: this.props.articleData.article_id
    };
    let customizationBody: any = (this.props.isTransfert && this.props.articleData?.marquage && this.props.articleData.surfaceEmplacements) ? {
      marquage_id: this.props.articleData.marquage.marquage_id,
      surface_emplacement_ids: this.props.articleData.surfaceEmplacements.map((elt: any) => elt.surface_emplacement_id),
      nb_colors: this.props.articleData.marquage.nb_couleurs
    } : {};

    if(this.state.defaultPrice) {
      params = {
        quantites: this.props.qtepriceFrom.quantite,
        quantite: this.props.qtepriceFrom.quantite,
        largeur: Math.round(this.props.qtepriceFrom.surface/2),
        hauteur: 2,
        isTransfer: this.props.isTransfert,
        article_id: this.props.defaultIdArticle
      };
      const marquageId= this.props.defaultIdArticle === 488223 ? 2 : 3;
      customizationBody = {
        marquage_id: marquageId
      };
    }
    axios.post(`${this.props.hostApi}/products/${this.props.productId}/calculate-price`, {
      ...params,
      ...customizationBody
    }, {
      ...getRequestConfig(),
      cancelToken: new axios.CancelToken((c: any) => {
        this.cancelRequestPrice = c;
      })
    }).then((res: any) => {
      this.setState({
        price: res.data.tarif
      }, () => {
        if(this.props.onPriceChange) {
          this.props.onPriceChange(res.data.tarif, this.state.defaultPrice);
        }
      });
    }).catch((err: any) => {
      if(axios.isCancel(err)) {
        this.cancelRequestPrice = null;
      } else {
        console.log(err);
      }
    });
  }

  render() {
    if(this._isMounted) {
      if (this.state.price === undefined || Object.keys(this.state.price).length === 0) {
        //return false;
      }

      const renderDateLivraisonEstimee = () => {
        if (this.state.price && this.state.price.date_livraison && this.state.price.date_livraison !== '0000-00-00') {
          const livraisonEstimee = moment(this.state.price.date_livraison).format('dddd DD MMM');

          return (
            <>
              <Icons icon="local_shipping" size={24}
                     className={'mr-2'}/>{this.props.t('estimated_delivery')}&nbsp;{livraisonEstimee}
            </>
          );
        }
      };
      const percentReduc = (this.state.price.ptBarre - this.state.price.pt) / this.state.price.ptBarre * 100;
      const economie = this.state.price.ptProchainPalier && this.state.price.pu > this.state.price.puProchainPalier ? this.state.price.pu - this.state.price.puProchainPalier : null;
      if (this.state.price.pu) {
        return (
          <>
            <div className="black font50">
              <div className={`${this.props.isTransfert ? 'd-flex align-items-center justify-content-center ' : '' }`}>
              <div className={'mr-4'}>
              {this.state.price.pt < this.state.price.ptBarre &&
              <div className={'font13'}>
                {this.props.t('discount_according_to_quantity')}
              </div>
              }
              <div className={`d-flex  align-items-center ${this.props.isTransfert ? 'justify-content-center' : 'justify-content-end'}`} >
                {this.state.price.pt < this.state.price.ptBarre &&
                <div className={'d-flex justify-content-center align-items-center'}>
                <span
                  className={'font25 text-decoration-throught mr-2'}>{renderPriceDecimals(this.state.price.ptBarre, this.lang)}</span>
                  <span className={'font18 badge badge-dark bg-black'}>-{percentReduc.toFixed(0)}%</span>
                </div>
                }
              </div>
                {this.props.isTransfert && this.state.price.pt < this.state.price.ptBarre &&
                <p className={'text-center font14 m-0 p-0'}>
                  {this.props.t('ie')} {this.state.price.pu.toFixed(2).replace('.', ',')}€&nbsp;<span className={'text-uppercase'}>{this.props.t('excl_tax')}</span>/{this.props.t('unit')}
                </p>
                }
              </div><div>
                <span className={'bold'}>{renderPriceDecimals(this.state.price.pt,this.lang)}</span>
            </div>
              </div>
              <div className={'text-center f-flex font14 ma-0 mt-2 pa-0'}>
                {this.canHavePrice() && !this.props.isTransfert && (this.props.articleData.quantite > 0 || this.state.defaultPrice) &&
                renderDateLivraisonEstimee()
                }
                {this.state.price.pt >= this.franco &&
                <span
                  className={'bold black ml-2 border border-dark border-left-0 border-right-0 border-bottom-0 font14 text-uppercase pa-1 px-2'}>{this.props.t('delivery_costs')} !</span>
                }
              </div>
            </div>
            {(this.state.price.ptProchainPalier && economie != null) &&
            <div
              className={'red font12 my-2 mx-0 py-1 text-center border border-red border-left-0 border-right-0 border-bottom-0 astucePrixDegressifs'}>
              <span className={' mr-1 text-uppercase'}>{this.props.t('tip')} :</span> <span
              className={' '}>{this.props.t('economize')} {economie.toFixed(2).replace('.', ',')}€&nbsp;{this.props.t('by_visual')}</span> {this.props.t('for')} {this.state.price.quantiteProchainPalier} {this.props.t('transfers')}
              &nbsp;!
            </div>
            }


          </>
        );
      } else if (this.props.priceFrom && !this.props.isTransfert) {
        return (
          <div>
          <div className={"d-flex font14 align-items-baseline"}>
            {this.props.t('price_from')}
            <span className={'bold ml-3 font50'}>{renderPriceDecimals(this.props.priceFrom,this.lang)}</span>
          </div>
        <div className={'bold black border border-dark text-center mt-2 font14 text-uppercase pa-1 px-3'}>{this.props.t('delivery_costs')} !</div>
            </div>
        )
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}

export default withTranslation('common')(withHostApi(PriceArticle));
